export default {
  formatCHNumber: function(v) {
    // Make number formatted not independent of execution environment.
    const n = Number(v);
    if (!isFinite(n)) return '';
    const [intPart, decPart] = Math.abs(n).toString().split('.');
    const grouped = intPart.replace(/\B(?=(\d{3})+(?!\d))/g, '\u2019');
    return (n < 0 ? '-' : '') + grouped + (decPart ? '.' + decPart : '');
  },
  price: function(v) {
    // Force correct separator until nodejs fixes libicu regression.
    return this.formatCHNumber(v)
  },
  date: function(d, f = 'de-CH', s = 'short') {
    if (!d) return "N/A"
    const formatter = new Intl.DateTimeFormat(f, {
      dateStyle: s
    });
    return formatter.format(new Date(d));
  }
}
